module.exports = __webpack_public_path__ + "static/media/svg-4.ed3ce751.svg";